import { Dtos, SuretyAccountId } from "@inrev/common";
import { useGlobalErrorMessageModal } from "@portal/providers/GlobalErrorHandlingProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { logError } from "../../utils/error";
import { useRequest } from "../../utils/request";
import { financialPeriodsQueryKey } from "../financials";
import { financialExtractionsQueryKey } from "../financials/financials.keys";
import {
	accountAttachmentsQueryKey,
	accountQueryKey,
	financialStatementsListQueryKey,
} from "./account.keys";

export function useAttachFinancialExtraction(accountId: SuretyAccountId) {
	const { post } = useRequest();
	const queryClient = useQueryClient();
	const { triggerErrorModal } = useGlobalErrorMessageModal();

	const mutation = useMutation({
		mutationFn: async (body: Dtos.FinancialExtractionAttach.Request) =>
			await post<Dtos.FinancialExtraction.Get.Response>(
				`/v2/surety/accounts/${accountId}/financial-extractions/attachments`,
				body,
			),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: financialPeriodsQueryKey(accountId),
			});
			queryClient.invalidateQueries({
				queryKey: financialExtractionsQueryKey(accountId),
			});
			queryClient.invalidateQueries({
				queryKey: financialStatementsListQueryKey(accountId),
			});
			queryClient.invalidateQueries({
				queryKey: accountQueryKey(accountId),
			});
			queryClient.invalidateQueries({
				queryKey: accountAttachmentsQueryKey(accountId),
			});
		},
		onError: (error: Error) => {
			logError(error);
			triggerErrorModal(error);
		},
	});

	return {
		attachFinancialExtraction: mutation.mutate,
		attachFinancialExtractionAsync: mutation.mutateAsync,
		attachFinancialExtractionIsLoading: mutation.isPending,
		attachFinancialExtractionSuccess: mutation.isSuccess,
	};
}
